import React, { useState } from 'react'
import classNames from 'classnames/bind'

import { InfoIcon } from 'images/icons/infoIcon/InfoIcon'
import styles from './tooltip.module.scss'

const cx = classNames.bind(styles)


export const ToolTip = (props) => {
    const [displayTooltip, setDisplayTooltip] = useState()
    const { message } = props

    const handleTooltipDisplay = () => {
        setDisplayTooltip(!displayTooltip)
    }

    return (
        <span
            className={cx(['tooltip-wrapper'], {
                'display-tooltip': displayTooltip === true
            })}
            onClick={() => handleTooltipDisplay()}
            role="button"
            tabIndex="0"
            onKeyDown={() => handleTooltipDisplay()}
        >
            <span
                className={cx('info-icon')}
            >
                {InfoIcon}
            </span>

            <div className={cx(['tooltip-message-wrapper', 'positioned-right'])}>
                <p>{message}</p>
            </div>

        </span>
    )
}

export default ToolTip